module.exports = __webpack_public_path__ + "static/media/039-monaco.7fa08071.svg";